module.exports = __webpack_public_path__ + "app.png?6be50a2f5f1df463e883d070a5ddf34d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/app.png
// module id = 58
// module chunks = 0